import React, { useState } from "react";
import {
  Card,
  Button,
  Typography,
  Space,
  Select,
  Alert,
  Modal,
} from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;
const { Option } = Select;

const images = [
  { label: "lamp", value: "lamp", os: "app" },
  { label: "wordpress", value: "wordpress", os: "app" },
  { label: "jitsi", value: "jitsi", os: "app" },
  { label: "nextcloud", value: "nextcloud", os: "app" },
  { label: "docker-ce", value: "docker-ce", os: "app" },
  { label: "gitlab", value: "gitlab", os: "app" },
];

export default function Rebuild() {
  const [image, setImage] = useState(null);

  const confirmRebuild = () => {
    Modal.confirm({
      title: "Rebuild Server",
      icon: <ExclamationCircleOutlined />,
      content: (
        <>
          <Paragraph>
            Rebuilding your server will power it off and overwrite its disk
            with the selected image.
          </Paragraph>
          <Paragraph>
            <Text strong>
              All previous data on the disk will be lost.
            </Text>
          </Paragraph>
        </>
      ),
      okText: "Rebuild",
      okType: "danger",
      cancelText: "Cancel",
    });
  };

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <Card>
        <Title level={5}>REBUILD</Title>

        <Paragraph>
          Rebuilding your server will power it off and overwrite its disk with
          the image you select.
        </Paragraph>

        <Alert
          type="error"
          showIcon
          message="All previous data on the disk will be lost."
        />

        <Space direction="vertical" style={{ width: "100%" }}>
          <Select
            placeholder="Image"
            value={image}
            onChange={setImage}
            style={{ width: "100%" }}
            showSearch
            optionFilterProp="label"
          >
            {images.map((img) => (
              <Option key={img.value} value={img.value} label={img.label}>
                <Space style={{ width: "100%", justifyContent: "space-between" }}>
                  {img.label}
                  <Text type="secondary">{img.os}</Text>
                </Space>
              </Option>
            ))}
          </Select>

          <Button
            danger
            type="primary"
            disabled={!image}
            onClick={confirmRebuild}
          >
            Rebuild
          </Button>
        </Space>
      </Card>
    </Space>
  );
}
